import React from "react";
import { Pickaxe, Flame, Factory, Building2, Layers3 } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const META = [
  { icon: Pickaxe, key: "s1", testid: "sector-mineria", tone: "from-amber-50 to-orange-50 text-amber-700" },
  { icon: Flame, key: "s2", testid: "sector-oilgas", tone: "from-rose-50 to-red-50 text-rose-700" },
  { icon: Factory, key: "s3", testid: "sector-manufactura", tone: "from-slate-100 to-slate-50 text-slate-700" },
  { icon: Building2, key: "s4", testid: "sector-infraestructura", tone: "from-sky-50 to-cyan-50 text-sky-700" },
];

export default function AtlasSectors() {
  const { t } = useI18n();
  return (
    <section
      id="sectores"
      data-testid="atlas-sectors"
      className="py-16 lg:py-24 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] text-[#6B46C1] uppercase bg-[#6B46C1]/10 rounded-full px-3 py-1.5">
            <Layers3 size={14} />
            {t("sectors.badge")}
          </div>
          <h2
            data-testid="sectors-title"
            className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-slate-900 leading-tight"
          >
            {t("sectors.titleA")}{" "}
            <span className="text-[#6B46C1]">{t("sectors.titleB")}</span>
          </h2>
          <p className="mt-4 text-slate-600 text-base sm:text-lg">
            {t("sectors.subtitle")}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {META.map(({ icon: Icon, key, testid, tone }) => (
            <div
              key={testid}
              data-testid={testid}
              className="group relative rounded-2xl border border-slate-200 bg-white p-6 hover:-translate-y-1 hover:border-[#6B46C1]/40 hover:shadow-lg hover:shadow-slate-200/60 transition-all duration-300"
            >
              <div
                className={`h-14 w-14 rounded-xl bg-gradient-to-br ${tone} flex items-center justify-center`}
              >
                <Icon size={26} strokeWidth={1.75} />
              </div>
              <h3 className="mt-5 font-display text-xl font-extrabold text-slate-900">
                {t(`sectors.${key}.name`)}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {t(`sectors.${key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
